import React, { Component, PropTypes } from 'react';
import Icon from './Icon';

export default class Fullsize extends Icon {
  render() {
    let { color, size, viewPortSize, className, ...props } = this.props;

    return (
      <svg
        width={size}
        height={size}
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox={'0 0 ' + viewPortSize + ' ' + viewPortSize}
        {...props}
      >
        <g fill={color}>
          <polygon points="6.4,8.5 2.8,12.2 2.8,9.1 1.2,9.1 1.2,14 2,14.8 6.9,14.8 6.9,13.2 3.8,13.2 7.5,9.6   " />
          <polygon points="14,1.2 9.1,1.2 9.1,2.8 12.2,2.8 8.5,6.4 9.6,7.5 13.2,3.8 13.2,6.9 14.8,6.9 14.8,2   " />
        </g>
      </svg>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Icons/Fullsize.js